var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2551_14472)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 11.5C6.90905 11.5 6.32389 11.3836 5.77792 11.1575C5.23196 10.9313 4.73588 10.5998 4.31802 10.182C3.90016 9.76412 3.56869 9.26804 3.34254 8.72208C3.1164 8.17611 3 7.59095 3 7C3 6.40905 3.1164 5.82389 3.34254 5.27792C3.56869 4.73196 3.90016 4.23588 4.31802 3.81802C4.73588 3.40016 5.23196 3.06869 5.77792 2.84254C6.32389 2.6164 6.90905 2.5 7.5 2.5C8.69347 2.5 9.83807 2.97411 10.682 3.81802C11.5259 4.66193 12 5.80653 12 7C12 8.19347 11.5259 9.33807 10.682 10.182C9.83807 11.0259 8.69347 11.5 7.5 11.5ZM7.5 12.5C8.15661 12.5 8.80679 12.6293 9.41342 12.8806C10.02 13.1319 10.5712 13.5002 11.0355 13.9645C11.4998 14.4288 11.8681 14.98 12.1194 15.5866C12.3707 16.1932 12.5 16.8434 12.5 17.5V21.5H2.5V17.5C2.5 16.1739 3.02678 14.9021 3.96447 13.9645C4.90215 13.0268 6.17392 12.5 7.5 12.5Z",
    fill: "currentFill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 11.5C17.9091 11.5 17.3239 11.3836 16.7779 11.1575C16.232 10.9313 15.7359 10.5998 15.318 10.182C14.9002 9.76412 14.5687 9.26804 14.3425 8.72208C14.1164 8.17611 14 7.59095 14 7C14 6.40905 14.1164 5.82389 14.3425 5.27792C14.5687 4.73196 14.9002 4.23588 15.318 3.81802C15.7359 3.40016 16.232 3.06869 16.7779 2.84254C17.3239 2.6164 17.9091 2.5 18.5 2.5C19.6935 2.5 20.8381 2.97411 21.682 3.81802C22.5259 4.66193 23 5.80653 23 7C23 8.19347 22.5259 9.33807 21.682 10.182C20.8381 11.0259 19.6935 11.5 18.5 11.5ZM18.5 12.5C19.1566 12.5 19.8068 12.6293 20.4134 12.8806C21.02 13.1319 21.5712 13.5002 22.0355 13.9645C22.4998 14.4288 22.8681 14.98 23.1194 15.5866C23.3707 16.1932 23.5 16.8434 23.5 17.5V21.5H13.5V17.5C13.5 16.1739 14.0268 14.9021 14.9645 13.9645C15.9021 13.0268 17.1739 12.5 18.5 12.5Z",
    fill: "currentFill"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2551_14472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentFill",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutral);
export default __webpack_public_path__ + "static/media/neutral.56a214d00f7bbe555370e1a1c7615ac9.svg";
export { ForwardRef as ReactComponent };